import FingerprintJS from '@fingerprintjs/fingerprintjs';

async function initFingerPrint() {
    if (!localStorage.getItem('visitorId')) {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const visitorId = result.visitorId;
        console.log("visitor-----", visitorId)
        localStorage.setItem("visitorId", visitorId);
    }
};
export { initFingerPrint }


// WEBPACK FOOTER //
// ./src/js/utils/initFingerPrint.js